import { dropTipoManut, dropStatusDocumento } from 'utils/drops';

const getOrçamentosFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    column: 'status',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento?.filter((f) =>
      [1, 6, 17, 19, 25, 26, 27, 28, 45]?.includes(f?.value)
    ),
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'vldocto',
    column: 'documento',
    label: 'Valor',
    type: 'currency',
    defaultValue: '',
  },
  {
    name: 'dtemissao.i',
    column: 'documento',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtemissao.f',
    column: 'documento',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'przent.i',
    column: 'documento',
    label: 'Prazo de Entrega Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'przent.f',
    column: 'documento',
    label: 'Prazo de Entrega Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtmodificacao.i',
    column: 'documento',
    label: 'Última Modificação Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtmodificacao.f',
    column: 'documento',
    label: 'Última Modificação Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'cliente',
    label: 'Cliente',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
    defaultValue: [],
  },
  { name: 'contato', column: 'cliente', label: 'Contato', defaultValue: '' },
  {
    name: 'cidade',
    column: 'cliente',
    label: 'Cidade',
    type: 'virtual-select',
    options: drops?.Cidade,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'equipamento',
    label: 'Equipamento',
    type: 'virtual-select',
    options: drops?.Equipamento,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'referencia',
    column: 'equipamento',
    label: 'Referência',
    defaultValue: '',
  },
  {
    name: 'cemarca',
    column: 'equipamento',
    label: 'Marca',
    type: 'select',
    options: drops?.Marca,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'modelo',
    column: 'equipamento',
    label: 'Modelo',
    type: 'select',
    options: drops?.Modelo,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'localizacao',
    column: 'equipamento',
    label: 'Localização',
    defaultValue: '',
  },
  {
    name: 'manutencao',
    label: 'Tipo da Manutenção',
    type: 'select',
    options: dropTipoManut,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'atendente',
    column: 'manutencao',
    label: 'Atendente',
    type: 'select',
    options: drops?.Users,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'tecnico',
    column: 'manutencao',
    label: 'Técnico',
    type: 'select',
    options: drops?.Users,
    multiple: true,
    defaultValue: [],
  },
];

export default getOrçamentosFilterFields;
